import { Component, Input } from '@angular/core';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { ITestimonial } from './testimonial.model';
import {
  CarouselComponent,
  CarouselModule,
  CarouselSlideDirective,
  OwlOptions,
} from 'ngx-owl-carousel-o';
import { CommonModule } from '@angular/common';
import { UrlDetectorPipe } from '../../Services/urlDetector.pipe';
import { PopupComponent } from '../popup/popup.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-testimonial',
  standalone: true,
  imports: [
    CarouselModule,
    CommonModule,
    UrlDetectorPipe,
    MatDialogModule,
    TranslateModule,
  ],
  providers: [
    CarouselComponent,
    CarouselSlideDirective,
    TranslatePipe,
    TranslateService,
  ],
  templateUrl: './testimonial.component.html',
  styleUrl: './testimonial.component.css',
})
export class TestimonialComponent {
  @Input() items: ITestimonial[] = [];
  customOptions: OwlOptions = {
    loop: true,
    margin: 5,
    nav: false,
    autoHeight: true,
    autoWidth: true,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  };

  constructor(private dialog: MatDialog) {}

  openArticle(article: ITestimonial): void {
    this.dialog.open(PopupComponent, {
      data: {
        title: article.title,
        description: article.description,
        images: [],
        videoUrl: article.videoLink,
      },
      width: 'calc(100%)',
      position: { top: '10%', left: 'calc(35%)' },
    });
  }
}
